import { useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './delete-repository-error-flag.i18n';

type Props = {
  id: ComponentFlagId;
  description: string;
} & HandleDismissedType;

const DeleteRepositoryErrorFlag = ({
  id,
  description,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      description={intl.formatMessage(
        messages.deleteRepositoryErrorDescription
      )}
      icon={
        <StatusErrorIcon
          spacing="spacious"
          label="Error"
          color={token('color.icon.danger')}
        />
      }
      title={intl.formatMessage(messages.deleteRepositoryErrorTitle)}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default DeleteRepositoryErrorFlag;
